module.exports = __webpack_public_path__ + "img/satisfied.f43b5ab5.gif";